module.exports = __webpack_public_path__ + "static/media/main idea.8b0d1e39.mp3";